import { useContext } from "react";
import UserContext from "../../contexts/UserContext";
import { Button, Icon } from 'semantic-ui-react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";


const MSLogin = () => {
    
    const userContext = useContext(UserContext)
    const { instance } = useMsal()

    const handleLogin = () => {
      instance.loginPopup(loginRequest).catch((error) => console.error(error));
    }

    const handleLogout = () => {
      instance.logoutRedirect();
    }

    if(userContext.isAuthenticated && userContext.authVendor === "okta"){
      return <></>
    }
    if(userContext.isAuthenticated && userContext.authVendor === "microsoft"){
      return  <div>
        <Button animated onClick={handleLogout}>
          <Button.Content visible >Logout</Button.Content>
          <Button.Content hidden><Icon name='log out'/></Button.Content>
        </Button>
      </div>
    }

    if(!userContext.isAuthenticated){
      return <Button size="small" id="msLogin" onClick={handleLogin}>Login With Microsoft</Button>
    }

    return <></>

}

export default MSLogin